/**
 * External Dependencies
 */
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import loadGoogleMapsApi from 'load-google-maps-api';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/**
 * Hamburger Toggle
 */
var hamburger = document.querySelector('.hamburger');
var navMobile = document.querySelector('.nav-mobile');
var activeSubmenu = document.querySelectorAll('.submenu.is-active');

hamburger.addEventListener('click', function () {
  hamburger.classList.toggle('is-active');
  navMobile.classList.toggle('is-active');

  if (!navMobile.classList.contains('is-active')) {
    activeSubmenu.forEach((submenu) => {
      submenu.classList.remove('is-active');
    });
    navMobileInner.classList.remove('showing-submenu');
  }
});

/**
 * Mobile Navigation Submenu
 */
var navigationButtons = document.querySelectorAll(
  '.nav-mobile .menu-item__button'
);
var navMobileInner = document.querySelector('.nav-mobile__inner');
var subNavigationButtons = document.querySelectorAll('.submenu__button');

navigationButtons.forEach((button) => {
  button.addEventListener('click', function () {
    var submenu = this.nextElementSibling;
    if (submenu) {
      navMobileInner.classList.add('showing-submenu');
      submenu.classList.add('is-active');
    }
  });
});

subNavigationButtons.forEach((button) => {
  button.addEventListener('click', function () {
    var submenu = this.closest('.submenu');
    navMobileInner.classList.remove('showing-submenu');
    submenu.classList.remove('is-active');
  });
});

/**
 * USP Swiper
 */
new Swiper('.usps .swiper', {
  modules: [Autoplay],
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
      autoplay: false,
      enabled: false,
      loop: false,
    },
  },
});

/**
 * Cover Slider
 */
const coverSlider = new Swiper('.wp-block-cover-slider__swiper', {
  modules: [Autoplay, Pagination],
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<span data-index="' +
        index +
        '" class="' +
        className +
        '"><span class="swiper-pagination-bullet--filled"></span></span>'
      );
    },
  },
});

/**
 * Logo Bar Slider
 */
const logoBarSlider = new Swiper('.wp-block-logo-bar .swiper', {
  modules: [Autoplay, Navigation],
  slidesPerView: 1,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1024: {
      slidesPerView: 5,
    },
  },
});

/**
 * Toggle Blog Article Content
 */
let moreButton = document.querySelectorAll('.post .read-more__button');

function toggleContent() {
  let postContent = this.closest('.read-more').previousElementSibling;
  if (postContent.style.maxHeight) {
    postContent.style.maxHeight = null;
    this.innerHTML = 'Weiterlesen...';
  } else {
    postContent.style.maxHeight = postContent.scrollHeight + 'px';
    this.innerHTML = 'Weniger anzeigen';
  }
}

moreButton.forEach((button) => button.addEventListener('click', toggleContent));

/**
 * Columns Slider
 */
const columnSliders = document.querySelectorAll('.wp-block-columns-slider');

columnSliders.forEach((columnSlider) => {
  new Swiper(columnSlider, {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 20,
    slideClass: 'wp-block-column',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1280: {
        enabled: false,
        slidesPerView: 3,
      },
    },
  });
});

/**
 * Slider
 */
const slider = new Swiper('.wp-block-slider .swiper', {
  modules: [Autoplay, Pagination],
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<span data-index="' +
        index +
        '" class="' +
        className +
        '"><span class="swiper-pagination-bullet--filled"></span></span>'
      );
    },
  },
});

const fadeElements = document.querySelectorAll(
  '.main > *:not(.wp-block-group.is-style-offset):not(.posts), .wp-block-group.is-style-offset > .wp-block-group__inner-container > *, .posts > *'
);

const observerOptions = {
  root: null,
  threshold: 0,
  rootMargin: '0px 0px -50px 0px',
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

fadeElements.forEach((element) => {
  if (!element.classList.contains('fadeup')) {
    element.classList.add('fadeup');
  }
  observer.observe(element);
});

const map = document.querySelector('.acf-map');

if (map) {
  var head = document.getElementsByTagName('head')[0];

  // Save the original method
  var insertBefore = head.insertBefore;

  // Replace it!
  head.insertBefore = function (newElement, referenceElement) {
    if (
      (newElement.href &&
        newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto') >
          -1) ||
      (newElement.href &&
        newElement.href.indexOf(
          '//fonts.googleapis.com/css?family=Google+Sans+Text'
        ) > -1)
    ) {
      return;
    }

    insertBefore.call(head, newElement, referenceElement);
  };

  const lat = parseFloat(document.querySelector('.marker').dataset.lat);
  const lng = parseFloat(document.querySelector('.marker').dataset.lng);

  loadGoogleMapsApi({
    key: 'AIzaSyDpIp0MgV7yXHJjErq9tMlXF4_cDYvXdeI',
  })
    .then(function (googleMaps) {
      const map = new googleMaps.Map(document.querySelector('.acf-map'), {
        center: {
          lat: lat,
          lng: lng,
        },
        mapId: '28ff54e65000a7d1',
        zoom: 14,
        disableDefaultUI: true,
      });
      const latlng = new googleMaps.LatLng(lat, lng);
      new googleMaps.Marker({
        position: latlng,
        map,
      });
    })
    .catch(function (error) {
      console.error(error);
    });
}
